'use client';

import { cn } from '@workspace/lib';
import { QuickPrompts } from '@workspace/widgets/QuickPrompts';
import { useAskGregSection } from './useAskGregSection';
import { AskGregSectionProps } from './ask-greg-section.types';
import { AskGregSectionButton, AskGregSectionHeader } from './ui';

export function AskGregSection({ ...props }: AskGregSectionProps) {
  const {
    title,
    subtitle,
    description,
    quickPromptsTitle,
    quickPrompts,
    isShowButton,
    backgroundColorClass,
    handleAskGregClick,
    handlePromptClick,
  } = useAskGregSection(props);

  return (
    <section className={cn(backgroundColorClass, 'w-full')}>
      <div className="porta-container px-md lg:px-4xl py-xl lg:py-3xl">
        <div className="gap-2xl lg:gap-4xl flex flex-col lg:flex-row lg:items-center">
          {/* Left Side */}
          <div className="w-full lg:flex-1 gap-lg flex flex-col items-start">
            <AskGregSectionHeader title={title} subtitle={subtitle} description={description} />

            {isShowButton && <AskGregSectionButton onClick={handleAskGregClick} />}
          </div>

          {/* Right Side */}
          <div className="w-full lg:flex-1 gap-sm md:gap-md flex flex-col items-center">
            <span className="font-semibold text-base text-secondary-400 text-center font-heading self-stretch">
              {quickPromptsTitle}
            </span>
            <QuickPrompts
              className="w-full lg:w-auto"
              buttonClassName="w-full lg:w-auto font-body font-semibold leading-5 md:leading-6 md:text-base lg:leading-6 rounded-round"
              prompts={quickPrompts.map((prompt) => prompt.text)}
              onPromptClick={handlePromptClick}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
